const isEligibleToShowBanner = (product) => {
  const { product: productName, daysToExpiry, status } = product;

  if (productName === 'WORKSPACE') {
    return false;
  }

  if (!['ACTIVE', 'EXPIRED'].includes(status)) {
    return false;
  }

  // daysToExpiry is always null for FREE tier subscriptions and the subscriptions that have so many remaining days to expire
  if (daysToExpiry === null && status === 'ACTIVE') {
    return false;
  }

  return true;
};

/**
 * Get the subscription with the soonest expiry or the first subscription that has expired
 * @param {Array} products
 * @return {Object}
 */
function getSoonestProductToExpire(products) {
  let minimumDaysToExpiry = Number.MAX_SAFE_INTEGER;
  let soonestExpiryIndex = -1;

  const filteredProducts = products.filter((product) => isEligibleToShowBanner(product));

  for (let i = 0; i < filteredProducts.length; i += 1) {
    const { daysToExpiry } = filteredProducts[i];

    if (!daysToExpiry || daysToExpiry < minimumDaysToExpiry) {
      minimumDaysToExpiry = daysToExpiry;
      soonestExpiryIndex = i;
    }
  }

  if (soonestExpiryIndex === -1) {
    return null;
  }

  return filteredProducts[soonestExpiryIndex];
}

export default getSoonestProductToExpire;